<template>
   <div class="file-upload-component">
      <div
         class="upload-box rounded p-5 text-center mb-3"
         @dragover.prevent
         @drop.prevent="handleDrop"
      >
         <div>
            <img
               src="@/assets/img/document-icon.svg"
               style="height: 25px; width: 30px"
               alt="document"
            />
            <div class="font-weight-bold file-upload-label">Drag and drop files here</div>
            <div class="file-upload-label text-muted mb-1">or</div>
            <button
               class="btn btn-primary file-upload-label btn-color"
               @click="triggerFileInput"
               :disabled="disabled"
               :class="{'btn-disabled': disabled}"
            >
               Select Files
            </button>
            <input
               type="file"
               ref="fileInput"
               class="d-none"
               @change="handleFileSelect"
               :accept="acceptFileTypes"
               :disabled="disabled"
            />
         </div>
         <small class="text-muted mt-4 file-upload-label">Limit 100MB</small>
      </div>

      <!-- Uploaded file preview -->
      <div
         v-if="file"
         class="upload-box--file py-1 px-4 rounded d-flex justify-content-start align-items-center"
      >
         <img src="@/assets/img/document-icon.svg" style="margin-right: 15px" alt="document" />
         <div class="d-flex flex-row align-items-center" style="gap: 20px">
            <div class="d-flex flex-column" style="width: 250px">
               <strong class="file-name">{{ file.name }}</strong>
               <div class="text-mutedmr-4" style="font-size: 11px">
                  File size: {{ formatSize(file.size) }}
               </div>
            </div>

            <b-form-group
               label="Account Name"
               label-for="input"
               class="description-class"
               label-class="mb-0 label-description"
               :invalid-feedback="accountNameError"
            >
               <b-form-input
                  id="input"
                  v-model="input"
                  @input="handleInput"
                  :state="accountNameInputState"
               ></b-form-input>
            </b-form-group>
         </div>
      </div>
   </div>
</template>

<script>
export default {
   name: 'FileUploadComponent',
   props: {
      currentFile: {
         type: null,
         default: null,
      },
      disabled: {
         type: Boolean,
         default: false,
      },
      acceptFileTypes: {
         type: String,
         default: '.csv,.xlsx,.xls',
      },
      accountNameError: {
         type: String,
         default: null,
      },
   },
   data() {
      return {
         input: '',
         file: null,
      };
   },
   computed: {
      accountNameInputState() {
         if (!this.input || this.input.trim().length === 0) {
            return null;
         }
         return this.accountNameError ? false : null;
      },
   },
   methods: {
      triggerFileInput() {
         if (this.disabled) return;
         this.$refs.fileInput.click();
      },
      handleFileSelect(event) {
         if (this.disabled) return;
         const selectedFiles = event.target.files;
         const validFiles = this.filterFiles(selectedFiles);
         this.file = validFiles[0];
         this.input = '';
         this.$emit('file-selected', {file: this.file, input: this.input});
      },
      handleInput() {
         if (this.disabled) return;
         this.$emit('file-selected', {file: this.file, input: this.input});
      },
      handleDrop(event) {
         event.preventDefault();
         if (this.disabled) return;
         const droppedFiles = event.dataTransfer.files;
         const validFiles = this.filterFiles(droppedFiles);
         this.file = validFiles[0];

         // Reset Account Name + notify parent immediately
         this.input = '';
         this.$emit('file-selected', {file: this.file, input: this.input});
      },
      filterFiles(files) {
         const validFiles = [];
         for (let i = 0; i < files.length; i++) {
            const file = files[i];
            const fileExtension = file.name.split('.').pop().toLowerCase();
            if (this.acceptFileTypes.includes(fileExtension)) {
               validFiles.push(file);
            }
         }
         return validFiles;
      },
      formatSize(bytes) {
         const kb = bytes / 1024;
         const mb = kb / 1024;
         const gb = mb / 1024;

         if (gb >= 1) {
            return `${gb.toFixed(1)} GB`;
         } else if (mb >= 1) {
            return `${mb.toFixed(1)} MB`;
         } else if (kb >= 1) {
            return `${kb.toFixed(1)} kB`;
         } else {
            return `${bytes} B`;
         }
      },
   },

   async created() {
      if (this.currentFile) {
         this.file = this.currentFile.file;
         this.input = this.currentFile.description;

         // Optional but harmless: keep parent in sync on mount
         this.$emit('file-selected', {file: this.file, input: this.input});
      }
   },
};
</script>

<style scoped>
.upload-box {
   border: 2px dashed #ccc;
}

.upload-box--file {
   background-color: #f9f9f9;
   margin-bottom: 10px;
}

.upload-box.dragover {
   background-color: #e9f5ff;
}
.file-upload-label {
   font-size: 13px;
}

.file-name {
   font-size: 13px;
}

.btn-color {
   background-color: #0978cd;
}

.description-class {
   font-size: 12px;
   margin-bottom: 2px !important;
}

::v-deep .label-description {
   font-size: 11px;
   color: grey;
   font-weight: normal;
}

::v-deep .p-5 {
   padding: 1rem !important;
}
</style>
